/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = "_blank";
            links[i].rel = "noreferrer noopener";
        }
    }


    //header cart counter functionality
    document.addEventListener('theme:cart:added', function(event) {
        const cartCounter = document.querySelectorAll('[data-cartcount]');
        if(cartCounter && window.cart && window.cart.cartCount){
            cartCounter.forEach((item)=>{
                item.dataset.cartcount = window.cart.cartCount;
            })
        }
    });


  document.querySelectorAll(".product-single__wrapper .product__accordion__title").forEach(button => {
    button.addEventListener("click", function() {
      setTimeout(() => {
        if ( this.isInViewport() == false ) {
          const buttonOffset = this.getBoundingClientRect().top + window.scrollY - 150;
          window.scrollTo({
            top: buttonOffset,
            behavior: "smooth"
        });
        }
      }, 300);
    });
  });


Element.prototype.isInViewport = function() {
    var rect = this.getBoundingClientRect();
    
    return (
        rect.bottom > 0 && 
        rect.top < (window.innerHeight || document.documentElement.clientHeight)
    );
};






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
